import { CARD_CTA_VARIANTS, type CardCtaVariant } from './constants';

// Sorteio fixo do aparelho (localStorage) e escolha manual de teste (sessão).
const CARD_CTA_ASSIGNED_KEY = 'pratigo:checkout:card-cta';
const CARD_CTA_FORCED_KEY = 'pratigo:checkout:card-cta-forced';

const VARIANTS = Object.keys(CARD_CTA_VARIANTS) as CardCtaVariant[];

function isCardCtaVariant(value: unknown): value is CardCtaVariant {
  return typeof value === 'string' && value in CARD_CTA_VARIANTS;
}

function read(storage: () => Storage, key: string): string | null {
  try {
    return storage().getItem(key);
  } catch {
    return null;
  }
}

function write(storage: () => Storage, key: string, value: string): void {
  try {
    storage().setItem(key, value);
  } catch {
    // Sem storage (aba anônima): vale só para esta página.
  }
}

/**
 * PRAT-209: teste A/B/C do apelo do cartão.
 * Cada aparelho sorteia uma variação na primeira visita e fica com ela, para a
 * conversão de cada variação ser comparável. `?cartao=a|b|c` força uma
 * variação só na sessão (para conferir as três), sem mexer no sorteio.
 */
export function resolveCardCtaVariant(
  search: string = typeof window !== 'undefined' ? window.location.search : '',
  random: () => number = Math.random
): CardCtaVariant {
  const fromUrl = new URLSearchParams(search).get('cartao')?.toLowerCase();
  if (isCardCtaVariant(fromUrl)) {
    write(() => sessionStorage, CARD_CTA_FORCED_KEY, fromUrl);
    return fromUrl;
  }

  const forced = read(() => sessionStorage, CARD_CTA_FORCED_KEY);
  if (isCardCtaVariant(forced)) return forced;

  const assigned = read(() => localStorage, CARD_CTA_ASSIGNED_KEY);
  if (isCardCtaVariant(assigned)) return assigned;

  const drawn = VARIANTS[Math.min(VARIANTS.length - 1, Math.floor(random() * VARIANTS.length))];
  write(() => localStorage, CARD_CTA_ASSIGNED_KEY, drawn);
  return drawn;
}
